module.exports = {"410771360":"开发区关堤乡","410771560":"振中街"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410771.json
// module id = 1592
// module chunks = 0